import { IonLoading, IonText, IonCard, IonGrid, IonContent, IonButton, IonButtons, IonToolbar, IonModal, IonAvatar, IonCol, IonIcon, IonImg, IonItem, IonLabel, IonNote, IonRow } from '@ionic/react';
import { walletOutline, closeOutline } from 'ionicons/icons';
import React, { useState, Component, useEffect }  from 'react';

import { LANGUAGE, GetStr } from "../language/Language";
import NServer, { handleRouteError, RegisterAppServices } from "../components/NServer";
import Vault from '../components/Vault';
import { showAlert } from '../components/Alert';

import NumInputCtrl from '../components/NumInputCtrl';
import PassCheckCtrl, { checkPasscode } from '../components/PassCheckCtrl';

import '../pages/Main.css';


interface PaymentDlgProp {
    show : boolean,
    dismiss : any,
    title : string,
    cap : string,
    desc : string,
    submit : any
}
  
const PaymentDlg: React.FC<PaymentDlgProp> = ({ show, dismiss, title, cap, desc, submit }) => {

    const [usd, setUSD] = useState("...");
    const [amount, setAmount] = useState("0");
    const [showPass, setShowPass] = useState(false);
    const [passKey, setPassKey] = useState("-- -- --");
    const [showLoading, setShowLoading] = useState(false);

    // need to refresh
    useEffect(() => {
        // init
        if (show)
        {
            setAmount("0");
            setPassKey("-- -- --");
            setShowPass(false);
            refreshMoney();
        }
    },[show]);

    // refresh the money
    const refreshMoney = async () => {
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key
        }

		var server = new NServer();
        await server.getList("nc_wallet", state);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            setUSD(server.data.usd);
        }
    }

    // select the amount
    const selectAmount = () => {
        // check whether amount is correct
        let curAmount = parseFloat(usd);
        let sendAmount = parseFloat(amount);

        if (sendAmount >= curAmount)
        {
            showAlert(GetStr(LANGUAGE.TXT_INVALID_SEND_AMT));
            return;
        }

        setShowPass(true);
    }

    const biometricSubmit = async (username : string, password : string) => {
        await submitMoney(password);
    }

    const send = async () => {
        await submitMoney(passKey);
    }

    const submitMoney = async (pass : string) => {
        
        setShowLoading(true);

        let amountFlt = parseFloat(amount);
        
        await submit(amountFlt, passKey);

        setShowLoading(false);
        
        // close the UI
        dismiss();
    }

    return (
        <IonModal
            isOpen={show}
            initialBreakpoint={ 0.9 }
            onDidDismiss={dismiss}
        >
            <IonLoading
                isOpen={showLoading}
                onDidDismiss={() => setShowLoading(false)}
                message={ GetStr(LANGUAGE.TXT_PLZ_WAIT) }
            />
            <div className="ion-page">
                <IonToolbar id="modal">
                    <IonItem lines="none">
                        <IonIcon slot="start" icon={walletOutline} />
                        <IonLabel>{ title }</IonLabel>
                    </IonItem>
                    <IonButtons slot="end">
                        <IonButton onClick={dismiss}>
                            <IonIcon icon={closeOutline} size="large"/>
                        </IonButton>
                    </IonButtons>
                </IonToolbar>
                <IonContent>
                    <IonGrid className="ion-no-padding main-content">
                        <IonRow>
                            <IonCol>
                            </IonCol>
                            <IonCol size-md="10" size-lg="8" size-xl="6" size="12">
                                {
                                    showPass ?
                                    /* show the passkey UI */
                                <div>
                                    <IonCard className="flat-card">
                                        <IonGrid>
                                            <IonRow className="ion-no-padding ion-no-margin">
                                                <IonCol className="ion-margin-top ion-margin-start">
                                                { cap }
                                                </IonCol>
                                            </IonRow>
                                            <IonRow>
                                                <IonCol className="ion-text-center">
                                                    <IonText className="balance-text">${amount}</IonText>
                                                </IonCol>
                                            </IonRow>
                                        </IonGrid>
                                    </IonCard>
                                    <PassCheckCtrl onChange={setPassKey} onSubmit={send} onBiometric={biometricSubmit} />
                                </div>
                                    :
                                    /* show select amount UI */
                                <div>
                                    <IonCard className="balance-card flat-card">
                                        <IonGrid>
                                            <IonRow>
                                                <IonCol className="ion-text-center ion-margin-top">
                                                    <IonText className="balance-text white" color="light">${usd}</IonText>
                                                </IonCol>
                                            </IonRow>
                                            <IonRow className="ion-no-padding ion-no-margin">
                                                <IonCol className="ion-text-center">
                                                    <IonText color="light"><small>{ GetStr(LANGUAGE.TXT_BALANCE) }</small></IonText>
                                                </IonCol>
                                            </IonRow>
                                        </IonGrid>
                                    </IonCard>
                                    <NumInputCtrl 
                                        amount={ amount }
                                        caption={ cap } 
                                        button={ desc }
                                        onChange={setAmount} 
                                        onSubmit={selectAmount} 
                                        deci={true}
                                    />
                                </div>
                                }
                            </IonCol>
                            <IonCol>
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonContent>
            </div>
        </IonModal>
    );
};
  
export default PaymentDlg;